module.exports = __webpack_public_path__ + "1ff754465ac1b461ee293f6174948c6f.jpg";